<template>
  <b-modal size="lg" ref="patientInfo-confirm-modal" no-close-on-backdrop no-close-on-esc>
    <template #modal-header>
      <h5> Patienteninformationen bestätigen</h5>
    </template>
    <b-container id="modal-container">
      Bitte bestätigen Sie die Patienteninformationen. Wenn die Informationen nicht korrekt sind, korrigieren Sie sie
      bitte.
      <ul>
        <li>Geburtsjahr:
          {{ (new Date(patientData.birthDate).getFullYear()) }}
        </li>
        <li>Geschlecht: {{ genderMap[patientData.sex] }}</li>
      </ul>
    </b-container>
    <template #modal-footer>
      <b-button @click="$emit('toPatientList')" variant="outline-danger">
        <b-icon-arrow-left-circle/>
        Patienteninformationen korrigieren
      </b-button>
      <b-button @click="$emit('patientInfoConfirmed')" variant="outline-success">
        Bestätigen
        <b-icon-check-circle/>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {localDateFormat} from "../../js/util";

export default {
  name: "PatientInfoConfirm",
  props: {
    show: Boolean,
    patientData: Object
  },
  emits: {
    patientInfoConfirmed: null,
    toPatientList: null
  },
  data() {
    return {
      localDateFormat: localDateFormat,
      genderMap: {
        m: 'Männlich',
        w: 'Weiblich'
      }
    }
  },
  mounted() {
    if (this.show) {
      this.$refs["patientInfo-confirm-modal"].show()
    } else {
      this.$refs["patientInfo-confirm-modal"].hide()
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    show(newVal) {
      this.$refs["patientInfo-confirm-modal"].toggle()
    }
  }
}
</script>

<style scoped>
#modal-container {
  padding-top: 100px;
  padding-bottom: 100px;
}
</style>